import { useNavigate } from 'react-router-dom'
import useHttpHandler from "../../../../hooks/httpHandler";
import {useEffect, useState} from "react";


const useRegister = () => {

    const {post, get} = useHttpHandler()
    const navigate = useNavigate()
    const [garagesList, setGaragesList] = useState([])
    const [loading, setLoading] = useState(false)

    const gotoVehicle = () => {
        navigate('/vehicle')
    }
    const onSubmitRegister=(values, actions)=>{
       post('auth/signup', values).then((res)=>{
           const data = res.data
           sessionStorage.setItem('token',data.accessToken)
           sessionStorage.setItem('userId',data.account_number)
            actions.setSubmitting(false)
           gotoVehicle()
        }).catch(err => {
            actions.setSubmitting(false)
        })
    }

    const getGarages = () => {
            get('garages').then((res)=>{
                 const data = res.data
                 setGaragesList(data.garages)
                 setLoading(false)
             }).catch(err => {
                 setLoading(false)
             })
    }

    useEffect(()=>{
        if(garagesList?.length >= 0) {
            getGarages()
        }
    },[])



    return {
        onSubmitRegister,
        garagesList
    }
}

export default useRegister